(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acerca-de-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initBanner(section) {
    if (!section || section.dataset.youtubeBannerReady === 'true') return;
    if (!window.AcercaCounterAnimation) return;
    section.dataset.youtubeBannerReady = 'true';

    var CounterAnim = window.AcercaCounterAnimation;

    var proxyUrl = section.getAttribute('data-proxy-url');
    var countEl = section.querySelector('[data-youtube-total-count]');
    var channelsScript = section.querySelector('[data-youtube-banner-channels]');
    var countAriaTemplate = section.getAttribute('data-count-aria-template') || '%{count} suscriptores en YouTube';
    var errorLabel = section.getAttribute('data-error-label') || 'No se pudo cargar el total de suscriptores';
    if (!proxyUrl || !countEl || !channelsScript) return;

    var channels = [];
    try {
      channels = JSON.parse(channelsScript.textContent || '[]').filter(function (channel) {
        return channel.channelId;
      });
    } catch (error) {
      channels = [];
    }
    if (channels.length === 0) return;

    var confirmedTotal = 0;
    var visualOffset = 0;
    var hasConfirmedTotal = false;
    var isInView = false;
    var useVisualOffset = section.getAttribute('data-use-visual-offset') !== 'false';
    var pollIntervalSeconds = Number(section.getAttribute('data-poll-interval-seconds'));
    var allowedPollIntervals = [5, 10, 20, 30, 60, 120];
    if (allowedPollIntervals.indexOf(pollIntervalSeconds) === -1) pollIntervalSeconds = 60;
    var pollIntervalMs = pollIntervalSeconds * 1000;
    var channelIds = channels.map(function (channel) { return channel.channelId; });
    var estimatedRate = Math.max(0, Number(section.getAttribute('data-estimated-rate')) || 0);
    var positiveDrift = Math.max(0, Number(section.getAttribute('data-positive-drift')) || 120);
    var negativeDrift = Math.max(0, Number(section.getAttribute('data-negative-drift')) || 20);
    var defaultDigitDuration = 2800;
    var revealDigitDuration = 5200;
    var sharedOffsetInterval = 12000;
    var channelSeed = channels.map(function (channel) {
      return channel.channelId;
    }).sort().join('|');

    function seededUnit(seed) {
      return CounterAnim.seededUnit(channelSeed + ':' + seed);
    }

    function formatCountAria(formatted) {
      return countAriaTemplate.replace('%{count}', formatted);
    }

    function currentTarget() {
      return confirmedTotal + visualOffset;
    }

    var counterAnim = CounterAnim.createOdometerCounter({
      countEl: countEl,
      classNames: {
        digit: 'acerca-de-banner__digit',
        reel: 'acerca-de-banner__digit-reel',
        separator: 'acerca-de-banner__separator'
      },
      formatAriaLabel: formatCountAria,
      useVisualOffset: useVisualOffset,
      canAnimate: function () { return isInView; },
      hasConfirmed: function () { return hasConfirmedTotal; },
      getTarget: currentTarget,
      updateOffset: function (now) { visualOffset = sharedVisualOffset(now); },
      seedFn: seededUnit,
      defaultDigitDuration: defaultDigitDuration,
      revealDigitDuration: revealDigitDuration,
      sharedOffsetInterval: sharedOffsetInterval
    });

    /**
     * Cosmetic "live ticking" fluctuation added on top of the last confirmed,
     * polled total. This is intentional (a common marketing-site touch) — it
     * is a deterministic, seeded pseudo-random value bounded by the
     * positive_drift/negative_drift settings, not a second real data source.
     * Store owners who don't want a display that can momentarily read a few
     * units off from the real polled count can disable it entirely via the
     * "Usar offset visual" (use_visual_offset) section setting.
     */
    function sharedVisualOffset(now) {
      if (!useVisualOffset) return 0;
      if (estimatedRate <= 0) return 0;

      var bucket = Math.floor(now / sharedOffsetInterval);
      var maxStep = Math.max(1, Math.ceil(estimatedRate / 10));
      var windowSize = 14;
      var offset = 0;

      for (var i = 0; i < windowSize; i++) {
        var roll = seededUnit((bucket - i) + ':roll');
        if (roll < 0.16) continue;
        if (roll < 0.23) {
          offset -= 1 + Math.floor(seededUnit((bucket - i) + ':down') * 2);
        } else {
          offset += 1 + Math.floor(seededUnit((bucket - i) + ':up') * Math.min(6, maxStep + 2));
        }
      }

      return Math.max(-negativeDrift, Math.min(positiveDrift, offset));
    }

    function handleUpdate(total) {
      confirmedTotal = total;
      hasConfirmedTotal = true;
      visualOffset = sharedVisualOffset(Date.now());
      if (isInView) {
        if (counterAnim.isRevealAnimating()) {
          return;
        }
        if (countEl.getAttribute('data-formatted-value')) {
          counterAnim.animateTo(currentTarget(), defaultDigitDuration);
          counterAnim.scheduleFluctuation();
        } else {
          counterAnim.playRevealAnimation();
        }
      } else {
        counterAnim.renderNumber(currentTarget(), { duration: 0 });
      }
    }

    function handleError() {
      if (!countEl.getAttribute('data-formatted-value')) {
        countEl.textContent = '---';
        countEl.setAttribute('aria-label', errorLabel);
      }
    }

    function handleCachedTotal(total) {
      confirmedTotal = total;
      hasConfirmedTotal = true;
      visualOffset = sharedVisualOffset(Date.now());
      if (isInView) {
        counterAnim.playRevealAnimation();
      } else {
        counterAnim.renderNumber(currentTarget(), { duration: 0 });
      }
    }

    var poller = CounterAnim.createSubscriberPoller({
      proxyUrl: proxyUrl,
      pollIntervalMs: pollIntervalMs,
      useCache: true,
      getChannelIds: function () { return channelIds; },
      onSuccess: handleUpdate,
      onError: handleError,
      onCachedTotal: handleCachedTotal
    });

    function setupVisibility() {
      if (!('IntersectionObserver' in window)) {
        isInView = true;
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            if (!isInView) {
              isInView = true;
              counterAnim.playRevealAnimation();
            }
          } else if (isInView) {
            isInView = false;
            counterAnim.stopFluctuation();
          }
        });
      }, { threshold: [0, 0.25, 0.5] });

      observer.observe(section);
    }

    setupVisibility();
    poller.start();

    window.addEventListener('pagehide', function () {
      poller.stop();
      counterAnim.stop();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="acerca-de-banner"]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (!window.AcercaCounterAnimation) {
    document.addEventListener('acerca-counter-animation:ready', initAll, { once: true });
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      initBanner(event.target.querySelector('[data-section-type="acerca-de-banner"]'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acerca-eventos"]) return;
  try {
    
(function () {
  'use strict';

  /* ── Filter switch logic ── */

  function initFilter(section) {
    var filterEl = section.querySelector('[data-eventos-filter]');
    var filterMobileEl = section.querySelector('[data-eventos-filter-mobile]');
    var upcomingCarousel = section.querySelector('[data-events-carousel]');
    var cards = Array.from(section.querySelectorAll('[data-event-block]'));
    var mobileGroups = Array.from(section.querySelectorAll('[data-mobile-group]'));
    var currentFilter = 'todos';

    function sortUpcomingEvents() {
      if (!upcomingCarousel || cards.length === 0) return;

      var statusRank = {
        disponible: 0,
        proximamente: 1
      };

      function getDateOrder(value) {
        var parts = value ? value.split('-') : [];
        if (parts.length !== 3) return 99999999;
        var year = Number(parts[0]);
        var month = Number(parts[1]);
        var day = Number(parts[2]);
        if (!year || !month || !day) return 99999999;
        return year * 10000 + month * 100 + day;
      }

      var entries = cards.map(function (card, index) {
        var group = card.previousElementSibling;
        var status = card.getAttribute('data-event-status') || 'proximamente';
        var dateValue = card.getAttribute('data-event-date') || '';

        return {
          card: card,
          group: group && group.getAttribute && group.getAttribute('data-mobile-group') ? group : null,
          statusOrder: Object.prototype.hasOwnProperty.call(statusRank, status) ? statusRank[status] : 99,
          dateOrder: getDateOrder(dateValue),
          index: index
        };
      });

      entries.sort(function (a, b) {
        return a.statusOrder - b.statusOrder || a.dateOrder - b.dateOrder || a.index - b.index;
      });

      var fragment = document.createDocumentFragment();
      entries.forEach(function (entry) {
        if (entry.group) fragment.appendChild(entry.group);
        fragment.appendChild(entry.card);
      });
      upcomingCarousel.appendChild(fragment);

      cards = Array.from(section.querySelectorAll('[data-event-block]'));
      mobileGroups = Array.from(section.querySelectorAll('[data-mobile-group]'));
    }

    function positionActiveBg(container) {
      if (!container) return;
      var bgContainer = container.querySelector('.acerca-eventos-filter__bg');
      var activeBg = container.querySelector('.acerca-eventos-filter__active-bg');
      var activeBtn = container.querySelector('.acerca-eventos-filter__btn.is-active');
      if (!bgContainer || !activeBg || !activeBtn) return;
      var containerRect = bgContainer.getBoundingClientRect();
      var btnRect = activeBtn.getBoundingClientRect();
      activeBg.style.left = (btnRect.left - containerRect.left) + 'px';
      activeBg.style.width = btnRect.width + 'px';
      activeBg.style.transform = 'none';
    }

    function applyFilter(target) {
      currentFilter = target;
      if (upcomingCarousel) {
        upcomingCarousel.setAttribute('data-current-filter', target);
      }

      // Update desktop filter
      if (filterEl) {
        filterEl.setAttribute('data-active-filter', target);
        var btns = filterEl.querySelectorAll('[data-filter-target]');
        btns.forEach(function (b) {
          var isActive = b.getAttribute('data-filter-target') === target;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        positionActiveBg(filterEl);
      }

      // Update mobile filter
      if (filterMobileEl) {
        var mBtns = filterMobileEl.querySelectorAll('[data-filter-target]');
        mBtns.forEach(function (b) {
          var isActive = b.getAttribute('data-filter-target') === target;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      mobileGroups.forEach(function (group) {
        group.classList.remove('is-active');
      });

      // Filter cards
      cards.forEach(function (card) {
        if (target === 'todos') {
          card.classList.remove('is-filtered');
          return;
        }
        var status = card.getAttribute('data-event-status');
        if (status === target) {
          card.classList.remove('is-filtered');
        } else {
          card.classList.add('is-filtered');
        }
      });

      if (target === 'todos' && window.matchMedia('(max-width: 768px)').matches) {
        ['disponible', 'proximamente'].forEach(function (status) {
          var hasVisibleCards = cards.some(function (card) {
            return card.getAttribute('data-event-status') === status && !card.classList.contains('is-filtered');
          });
          if (!hasVisibleCards) return;
          var group = mobileGroups.find(function (item) {
            return item.getAttribute('data-mobile-group') === status;
          });
          if (group) group.classList.add('is-active');
        });
      }
    }

    // Desktop filter clicks
    if (filterEl) {
      filterEl.querySelectorAll('[data-filter-target]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyFilter(btn.getAttribute('data-filter-target'));
        });
      });
    }

    // Mobile filter clicks
    if (filterMobileEl) {
      filterMobileEl.querySelectorAll('[data-filter-target]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyFilter(btn.getAttribute('data-filter-target'));
        });
      });
    }

    // Recalculate active-bg position on resize (debounced)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyFilter(currentFilter);
        positionActiveBg(filterEl);
      }, 150);
    });

    try {
      sortUpcomingEvents();
    } catch (error) {
      console.warn('No se pudo ordenar Proximos Eventos por fecha.', error);
    }
    applyFilter('todos');
    positionActiveBg(filterEl);
  }

  /* ── Shared carousel logic (past events only) ── */

  function initCarousel(wrapper, dotsEl) {
    if (!wrapper || !dotsEl) return;
    var cards = Array.from(wrapper.children);
    if (cards.length === 0) return;

    var activeIndex = 0;

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function updateDots() {
      if (!isMobile()) {
        dotsEl.style.display = 'none';
        return;
      }
      dotsEl.style.display = 'flex';
      dotsEl.innerHTML = '';
      cards.forEach(function (card, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = i === activeIndex ? 'is-active' : '';
        btn.setAttribute('aria-label', 'Ir al evento ' + (i + 1));
        btn.addEventListener('click', function () {
          var cardLeft = card.offsetLeft;
          var wrapperRect = wrapper.getBoundingClientRect();
          var cardWidth = card.offsetWidth;
          var targetScroll = cardLeft - (wrapperRect.width / 2) + (cardWidth / 2);
          wrapper.scrollTo({ left: targetScroll, behavior: 'smooth' });
        });
        dotsEl.appendChild(btn);
      });
    }

    function updateActiveDot() {
      if (!isMobile()) return;
      var wrapperRect = wrapper.getBoundingClientRect();
      var centerX = wrapperRect.left + wrapperRect.width / 2;
      var bestIdx = 0;
      var bestDist = Infinity;

      cards.forEach(function (card, i) {
        var cardRect = card.getBoundingClientRect();
        var cardCenter = cardRect.left + cardRect.width / 2;
        var dist = Math.abs(centerX - cardCenter);
        if (dist < bestDist) {
          bestDist = dist;
          bestIdx = i;
        }
      });

      if (bestIdx !== activeIndex) {
        activeIndex = bestIdx;
        Array.from(dotsEl.children).forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      }
    }

    updateDots();
    updateActiveDot();

    var scrollRaf = null;
    wrapper.addEventListener('scroll', function () {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        updateActiveDot();
        scrollRaf = null;
      });
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) {
          updateDots();
          updateActiveDot();
        } else {
          dotsEl.style.display = 'none';
          wrapper.scrollLeft = 0;
        }
      }, 150);
    });
  }

  /* ── Event card click handlers ── */

  function initEventCards(container) {
    if (!container) return;
    var cards = container.querySelectorAll('[data-event-block]');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var purchaseUrl = card.getAttribute('data-purchase-url');
        var formId = card.getAttribute('data-omnisend-form-id');

        if (purchaseUrl) {
          if (/^https?:\/\//i.test(purchaseUrl)) {
            window.location.href = purchaseUrl;
          }
        } else if (formId) {
          if (typeof window.omnisend !== 'undefined') {
            window.omnisend.push(['openForm', formId]);
          }
        }
      });
    });
  }

  /* ── Center carousel when items don't overflow ── */

  function centerCarousel(carousel) {
    if (!carousel) return;
    // On mobile upcoming (vertical), skip
    if (window.matchMedia('(max-width: 768px)').matches && carousel.closest('[data-events-carousel]')) return;

    var hasOverflow = carousel.scrollWidth > carousel.clientWidth;
    if (!hasOverflow) {
      carousel.style.justifyContent = 'center';
    }
  }

  function initAcercaEventos(section) {
    if (!section || section.dataset.acercaEventosReady === 'true') return;
    section.dataset.acercaEventosReady = 'true';

    // Filter
    initFilter(section);

    // Upcoming event cards
    var upcomingCarousel = section.querySelector('[data-events-carousel]');
    if (upcomingCarousel) {
      initEventCards(upcomingCarousel);
      centerCarousel(upcomingCarousel);
    }

    // Past carousel
    var pastCarousel = section.querySelector('[data-past-carousel]');
    var pastDots = section.querySelector('[data-past-dots]');
    if (pastCarousel) {
      initCarousel(pastCarousel, pastDots);
      centerCarousel(pastCarousel);

      // Navigate to gallery on past event card click
      pastCarousel.addEventListener('click', function (e) {
        var card = e.target.closest('.grid-gallery-card');
        if (!card || !pastCarousel.contains(card)) return;

        var title = card.dataset.galleryTitle;
        var handle = card.dataset.galleryHandle;
        var galleryUrl = pastCarousel.getAttribute('data-gallery-url') || '/pages/galeria';
        if (!title && !handle) return;

        var url = galleryUrl + '?album=' + encodeURIComponent(title || '');
        if (handle) {
          url += '&gallery=' + encodeURIComponent(handle);
        }
        window.location.href = url;
      });
    }
  }

  document.querySelectorAll('[data-section-type="acerca-eventos"]').forEach(initAcercaEventos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acerca-page"]) return;
  try {
    
(function () {
  function initAcercaPage(section) {
    if (!section || section.dataset.acercaPageReady === 'true') return;

    var switchEl = section.querySelector('[data-acerca-switch]');
    if (!switchEl) return;

    section.dataset.acercaPageReady = 'true';

    var buttons = switchEl.querySelectorAll('[data-switch-target]');
    var contentContainers = {
      eventos: section.querySelector('[data-acerca-content="eventos"]'),
      historia: section.querySelector('[data-acerca-content="historia"]')
    };
    var currentTab = '';

    function tabFromHash(hash) {
      var hashValue = (hash || '').replace('#', '');
      if (hashValue === 'eventos' || hashValue === 'historia') return hashValue;
      return '';
    }

    function isValidTab(tabId) {
      return tabId === 'eventos' || tabId === 'historia';
    }

    function tabFromUrl(url) {
      var hashTab = tabFromHash(url.hash);
      if (hashTab) return hashTab;

      var queryTab = url.searchParams.get('tab');
      return isValidTab(queryTab) ? queryTab : '';
    }

    function updateSections(tabId) {
      var root = section.closest('main') || document;
      var sectionEls = root.querySelectorAll('[data-acerca-section]');
      sectionEls.forEach(function (el) {
        if (el.getAttribute('data-acerca-section') === tabId) {
          el.classList.remove('is-hidden');
        } else {
          el.classList.add('is-hidden');
        }
      });
    }

    function scrollToTabSection(tabId) {
      var root = section.closest('main') || document;
      var target = root.querySelector('[data-acerca-section="' + tabId + '"]') || contentContainers[tabId] || section;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function activateTab(tabId, updateHash, options) {
      if (!isValidTab(tabId)) return;
      options = options || {};

      if (tabId !== currentTab) {
        buttons.forEach(function (btn) {
          var target = btn.getAttribute('data-switch-target');
          var isActive = target === tabId;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        Object.keys(contentContainers).forEach(function (key) {
          if (!contentContainers[key]) return;
          contentContainers[key].classList.toggle('is-hidden', key !== tabId);
        });

        switchEl.setAttribute('data-active-tab', tabId);
        updateSections(tabId);
        currentTab = tabId;
      }

      if (updateHash !== false) {
        try {
          history.replaceState(null, '', '#' + tabId);
        } catch (error) {
          // El editor de temas puede bloquear cambios de URL; el switch ya cambió.
        }
      }

      if (options.scroll === true) {
        scrollToTabSection(tabId);
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.getAttribute('data-switch-target'));
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(btn.getAttribute('data-switch-target'));
        }
      });
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;

      var linkUrl;
      try {
        linkUrl = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      var tabId = tabFromUrl(linkUrl);
      if (!tabId) return;
      if (linkUrl.origin !== window.location.origin || linkUrl.pathname !== window.location.pathname) return;

      e.preventDefault();
      activateTab(tabId, true, { scroll: true });
    });

    window.addEventListener('hashchange', function () {
      var tabId = tabFromUrl(new URL(window.location.href));
      if (tabId) activateTab(tabId, false, { scroll: true });
    });

    var initialUrlTab = tabFromUrl(new URL(window.location.href));
    activateTab(initialUrlTab || 'eventos', false, { scroll: !!initialUrlTab });
  }

  function initAllAcercaPages() {
    document.querySelectorAll('[data-section-type="acerca-page"]').forEach(initAcercaPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAcercaPages);
  } else {
    initAllAcercaPages();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      initAcercaPage(event.target.querySelector('[data-section-type="acerca-page"]'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acerca-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var section = document.querySelector('[data-section-type="acerca-timeline"]');
  if (!section) return;

  var wrapper = section.querySelector('.acerca-timeline__wrapper');
  var track = section.querySelector('.acerca-timeline__progress-track');
  if (!wrapper || !track) return;

  function updateProgress() {
    var scrollLeft = wrapper.scrollLeft;
    var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
    if (maxScroll <= 0) {
      track.style.width = '100%';
      return;
    }
    var pct = (scrollLeft / maxScroll) * 100;
    track.style.width = pct + '%';
  }

  var rafId = null;
  wrapper.addEventListener('scroll', function () {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      updateProgress();
      rafId = null;
    });
  }, { passive: true });

  // Recalculate on resize / layout changes
  var ro = new ResizeObserver(function () { updateProgress(); });
  ro.observe(wrapper);
  ro.observe(section);

  // Keyboard navigation
  wrapper.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      wrapper.scrollBy({ left: -320, behavior: 'smooth' });
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      wrapper.scrollBy({ left: 320, behavior: 'smooth' });
    }
  });

  // Initial state
  updateProgress();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acerca-youtube-counter"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initYoutubeCounter() {
  if (!window.AcercaCounterAnimation) return;
  var CounterAnim = window.AcercaCounterAnimation;

  var section = document.querySelector('[data-section-type="acerca-youtube-counter"]');
  if (!section) return;

  var proxyUrl = section.getAttribute('data-proxy-url');
  var countEl = section.querySelector('[data-youtube-count]');
  var skeletonEl = section.querySelector('.yt-counter-main__count-skeleton');
  var sidebar = section.querySelector('.yt-counter-sidebar');

  if (!countEl) return;
  if (!proxyUrl) {
    countEl.textContent = '---';
    countEl.setAttribute('aria-label', 'Configura el Proxy URL en la sección');
    if (skeletonEl) skeletonEl.remove();
    return;
  }

  var allowedPollIntervals = [5, 10, 20, 30, 60, 120];
  var pollIntervalSeconds = Number(section.getAttribute('data-poll-interval-seconds'));
  if (allowedPollIntervals.indexOf(pollIntervalSeconds) === -1) pollIntervalSeconds = 60;
  var POLL_INTERVAL = pollIntervalSeconds * 1000;
  var isSectionActive = !section.classList.contains('is-hidden');
  var isInView = false;
  var useVisualOffset = section.getAttribute('data-use-visual-offset') !== 'false';
  var confirmedCount = 0;
  var visualOffset = 0;
  var hasConfirmedCount = false;
  var defaultDigitDuration = 2800;
  var revealDigitDuration = 5200;
  var sharedOffsetInterval = 12000;
  var positiveDrift = 30;
  var negativeDrift = 10;

  /* ── Channel data from sidebar buttons ── */
  var channelButtons = sidebar ? sidebar.querySelectorAll('.yt-counter-avatar') : [];
  var channels = [];
  for (var i = 0; i < channelButtons.length; i++) {
    channels.push({
      button: channelButtons[i],
      channelId: channelButtons[i].getAttribute('data-channel-id'),
      channelName: channelButtons[i].getAttribute('data-channel-name'),
      youtubeUrl: channelButtons[i].getAttribute('data-youtube-url'),
      imageUrl: channelButtons[i].getAttribute('data-image-url')
    });
  }

  var activeIndex = 0;
  for (var j = 0; j < channels.length; j++) {
    if (channels[j].button.classList.contains('yt-counter-avatar--active')) {
      activeIndex = j;
      break;
    }
  }

  var mainImage = section.querySelector('[data-active-image]');
  var mainName = section.querySelector('[data-active-name]');
  var mainUrl = section.querySelector('[data-active-url]');

  /* ── LIVE indicator ── */
  var liveDot = document.createElement('span');
  liveDot.className = 'yt-counter-live';
  liveDot.setAttribute('aria-hidden', 'true');
  liveDot.innerHTML = '<span class="yt-counter-live__dot"></span>EN VIVO';
  var countLabel = section.querySelector('.yt-counter-main__count-label');
  if (countLabel) countLabel.parentNode.insertBefore(liveDot, countLabel);

  /* ── Helpers ── */
  function activeChannelId() {
    return channels[activeIndex] ? channels[activeIndex].channelId : '';
  }

  function currentTarget() {
    return confirmedCount + visualOffset;
  }

  function canAnimate() {
    return isSectionActive && isInView;
  }

  function seededUnit(channelId, seed) {
    return CounterAnim.seededUnit(channelId + ':' + seed);
  }

  /**
   * Cosmetic "live ticking" fluctuation added on top of the last confirmed,
   * polled count. Intentional — a deterministic, seeded pseudo-random value
   * bounded by positiveDrift/negativeDrift, not a second real data source.
   * Disable entirely via the "Usar offset visual" (use_visual_offset) setting.
   */
  function channelVisualOffset(channelId, now) {
    if (!useVisualOffset || !channelId) return 0;

    var bucket = Math.floor(now / sharedOffsetInterval);
    var windowSize = 14;
    var offset = 0;

    for (var i = 0; i < windowSize; i++) {
      var roll = seededUnit(channelId, (bucket - i) + ':roll');
      if (roll < 0.16) continue;
      if (roll < 0.23) {
        offset -= 1 + Math.floor(seededUnit(channelId, (bucket - i) + ':down') * 2);
      } else {
        offset += 1 + Math.floor(seededUnit(channelId, (bucket - i) + ':up') * 4);
      }
    }

    offset = Math.max(-negativeDrift, Math.min(positiveDrift, offset));
    if (offset === 0) {
      offset = seededUnit(channelId, bucket + ':nudge') < 0.3 ? -1 : 1;
    }

    return offset;
  }

  var counterAnim = CounterAnim.createOdometerCounter({
    countEl: countEl,
    skeletonEl: skeletonEl,
    classNames: {
      digit: 'yt-counter-digit',
      reel: 'yt-counter-digit__reel',
      separator: 'yt-counter-separator'
    },
    formatAriaLabel: function (formatted) { return formatted + ' suscriptores'; },
    useVisualOffset: useVisualOffset,
    canAnimate: canAnimate,
    hasConfirmed: function () { return hasConfirmedCount; },
    getTarget: currentTarget,
    updateOffset: function (now) { visualOffset = channelVisualOffset(activeChannelId(), now); },
    seedFn: function (suffix) { return seededUnit(activeChannelId(), suffix); },
    defaultDigitDuration: defaultDigitDuration,
    revealDigitDuration: revealDigitDuration,
    sharedOffsetInterval: sharedOffsetInterval
  });

  function showError() {
    if (skeletonEl) skeletonEl.remove();
    countEl.textContent = '---';
    countEl.setAttribute('aria-label', 'No se pudo cargar el contador');
    counterAnim.clearFormattedState();
  }

  function handleUpdate(total) {
    confirmedCount = total;
    hasConfirmedCount = true;
    visualOffset = channelVisualOffset(activeChannelId(), Date.now());
    if (canAnimate()) {
      if (counterAnim.isRevealAnimating()) {
        return;
      }
      if (countEl.getAttribute('data-formatted-value')) {
        counterAnim.animateTo(currentTarget(), defaultDigitDuration);
        counterAnim.scheduleFluctuation();
      } else {
        counterAnim.playRevealAnimation();
      }
    } else {
      counterAnim.renderNumber(currentTarget(), { duration: 0 });
    }
  }

  function handleCachedTotal(total) {
    confirmedCount = total;
    hasConfirmedCount = true;
    visualOffset = channelVisualOffset(activeChannelId(), Date.now());
    if (canAnimate()) {
      counterAnim.playRevealAnimation();
    } else {
      counterAnim.renderNumber(currentTarget(), { duration: 0 });
    }
  }

  var poller = CounterAnim.createSubscriberPoller({
    proxyUrl: proxyUrl,
    pollIntervalMs: POLL_INTERVAL,
    useCache: true,
    getChannelIds: function () { return [activeChannelId()]; },
    onSuccess: handleUpdate,
    onError: showError,
    onCachedTotal: handleCachedTotal
  });

  /* ── Channel switching ── */
  function setActiveChannel(index) {
    if (index === activeIndex) return;

    channels[activeIndex].button.classList.remove('yt-counter-avatar--active');
    channels[activeIndex].button.setAttribute('aria-selected', 'false');

    activeIndex = index;
    channels[activeIndex].button.classList.add('yt-counter-avatar--active');
    channels[activeIndex].button.setAttribute('aria-selected', 'true');

    if (mainImage && channels[activeIndex].imageUrl) {
      mainImage.classList.add('is-switching');
      mainImage.src = channels[activeIndex].imageUrl;
      mainImage.alt = channels[activeIndex].channelName;
      mainImage.onload = function () { mainImage.classList.remove('is-switching'); };
    }

    if (mainName) mainName.textContent = channels[activeIndex].channelName;
    if (mainUrl) mainUrl.href = channels[activeIndex].youtubeUrl || '#';

    restartPolling();
  }

  /* ── Polling ── */
  function startPolling() {
    if (channels.length === 0) return;
    if (!isSectionActive) return;
    poller.start();
    if (liveDot) liveDot.classList.add('yt-counter-live--active');
  }

  function stopPolling() {
    poller.stop();
    counterAnim.stop();
    if (liveDot) liveDot.classList.remove('yt-counter-live--active');
  }

  function restartPolling() {
    confirmedCount = 0;
    visualOffset = 0;
    hasConfirmedCount = false;
    counterAnim.reset();
    stopPolling();
    startPolling();
  }

  /* ── Visibility observer (pause when section hidden by toggle) ── */
  function onSectionVisibilityChange() {
    var nextActive = !section.classList.contains('is-hidden');
    if (nextActive === isSectionActive) return;

    isSectionActive = nextActive;
    if (isSectionActive) {
      startPolling();
    } else {
      stopPolling();
    }
  }

  function onViewportChange(nextInView) {
    if (nextInView === isInView) return;

    isInView = nextInView;
    if (isInView) {
      visualOffset = channelVisualOffset(activeChannelId(), Date.now());
      if (hasConfirmedCount && isSectionActive) {
        counterAnim.playRevealAnimation();
      } else {
        counterAnim.scheduleFluctuation();
      }
    } else {
      counterAnim.cancelAnimation();
    }
  }

  function setupViewportObserver() {
    if (!('IntersectionObserver' in window)) {
      isInView = true;
      return;
    }

    var viewportObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].target === section) {
          onViewportChange(entries[i].isIntersecting && entries[i].intersectionRatio >= 0.25);
        }
      }
    }, { threshold: [0, 0.25, 0.5] });

    viewportObserver.observe(section);
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        if (mutations[m].type === 'attributes') {
          onSectionVisibilityChange();
        } else if (mutations[m].type === 'childList') {
          var removed = Array.from(mutations[m].removedNodes);
          if (removed.indexOf(section) !== -1) {
            stopPolling();
            observer.disconnect();
            return;
          }
        }
      }
    });
    observer.observe(section, { attributes: true, attributeFilter: ['class'], childList: true, subtree: false });
  }

  /* ── Click handlers ── */
  for (var k = 0; k < channels.length; k++) {
    (function (index) {
      channels[index].button.addEventListener('click', function () { setActiveChannel(index); });
    })(k);
  }

  /* ── Init ── */
  setupViewportObserver();
  startPolling();
  }

  if (window.AcercaCounterAnimation) {
    initYoutubeCounter();
  } else {
    document.addEventListener('acerca-counter-animation:ready', initYoutubeCounter, { once: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-highlight"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-section-type="collection-highlight"]');
    if (!section) return;

    const wrapper = section.querySelector('.collection-carrousel-wrapper');
    const carousel = section.querySelector('[data-carousel]');
    const dotsWrap = section.querySelector('[data-dots]');
    
    if (!wrapper || !carousel || !dotsWrap) return;

    const cards = Array.from(carousel.querySelectorAll('.collection-card'));
    if (cards.length <= 1) {
      dotsWrap.style.display = 'none';
      return;
    }

    let isMobile = () => window.matchMedia('(max-width: 600px)').matches;
    let activeIndex = 0;

    function updateDots() {
      if (!isMobile()) {
        dotsWrap.style.display = 'none';
        return;
      }
      dotsWrap.style.display = 'flex';
      dotsWrap.innerHTML = '';

      cards.forEach((card, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = i === activeIndex ? 'is-active' : '';
        btn.setAttribute('aria-label', 'Ver colección ' + (i + 1));
        btn.dataset.index = i;
        btn.addEventListener('click', () => {
          // Calculate scroll position to center the card
          const cardLeft = card.offsetLeft;
          const wrapperWidth = wrapper.clientWidth;
          const cardWidth = card.offsetWidth;
          const targetScroll = cardLeft - (wrapperWidth / 2) + (cardWidth / 2);
          
          wrapper.scrollTo({ left: targetScroll, behavior: 'smooth' });
        });
        dotsWrap.appendChild(btn);
      });
    }

    function updateActiveDot() {
      if (!isMobile()) return;

      const wrapperRect = wrapper.getBoundingClientRect();
      const centerX = wrapperRect.left + wrapperRect.width / 2;

      let bestIdx = 0;
      let bestDist = Infinity;

      cards.forEach((card, idx) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const dist = Math.abs(centerX - cardCenter);
        if (dist < bestDist) {
          bestDist = dist;
          bestIdx = idx;
        }
      });

      if (bestIdx !== activeIndex) {
        activeIndex = bestIdx;
        Array.from(dotsWrap.children).forEach((dot, i) => {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      }
    }

    let scrollRaf = null;
    wrapper.addEventListener('scroll', () => {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(() => {
        updateActiveDot();
        scrollRaf = null;
      });
    }, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (isMobile()) {
          updateDots();
          updateActiveDot();
        } else {
          dotsWrap.style.display = 'none';
          // Reset scroll position on desktop
          wrapper.scrollLeft = 0;
        }
      }, 150);
    });

    // Initial setup
    updateDots();
    updateActiveDot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  // FAQ toggle logic
  document.addEventListener('DOMContentLoaded', function() {
    var faqs = document.querySelectorAll('.faq');
    faqs.forEach(function(faq) {
      var headers = faq.querySelectorAll('h2');
      headers.forEach(function(header) {
        header.style.cursor = 'pointer';
        header.addEventListener('click', function() {
          var next = header.nextElementSibling;
          while (next && next.tagName && next.tagName.toLowerCase() !== 'p') {
            next = next.nextElementSibling;
          }
          if (next && next.tagName && next.tagName.toLowerCase() === 'p') {
            if (next.style.display === 'none') {
              next.style.display = '';
            } else {
              next.style.display = 'none';
            }
          }
        });
      });

// Opcional: ocultar todos los <p> al inicio
      var paragraphs = faq.querySelectorAll('p');
      paragraphs.forEach(function(p) {
        p.style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
